import { Pagination } from 'antd';
import withLoading from 'common/spinner/components/with-loading';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isToggleEnabled } from 'react-awesome-feature-toggles';
import { types } from 'utils/mappings';
import { withRouter } from 'utils/withRouter';
import { referenceTypes } from '../../../utils/app-configs';
import { Results } from '../overview/search-overview-results';
import SearchResultBlock from '../search-result-block';

class SearchResults extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    results: PropTypes.object.isRequired,
    activePage: PropTypes.number.isRequired,
    changePage: PropTypes.func.isRequired,
  };

  renderPagination = () => {
    const { results, activePage, changePage } = this.props;
    return (
      <Pagination
        defaultCurrent={activePage}
        total={results.totalCount < 1000 ? results.totalCount : 1000}
        pageSize={results.pageSize || 24}
        onChange={changePage}
        showTitle={false}
        showSizeChanger={false}
      />
    );
  };

  render() {
    const { results, type } = this.props;
    return (
      <>
        <Results>
          {
            <SearchResultBlock
              name={types[type?.toLowerCase()]?.displayTextTranslationKey}
              {...results}
              fullPage={true}
              showAllButton={false}
              // TODO: remove once FF is no longer used
              blockRedirect={
                type?.toLowerCase() === referenceTypes.functionallocation &&
                !isToggleEnabled('functionalLocationInfo')
              }
            />
          }
        </Results>
        {this.renderPagination()}
      </>
    );
  }
}

export default withRouter(withLoading(SearchResults));
